import styled from 'styled-components'
import config from 'config'
import { push } from 'connected-react-router'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import FloatingActionBtn from 'ui/components/FloatingActionBtn'
import { useIntl } from 'react-intl'
import useKeywords from './useKeywords'
import KeywordTable from './KeywordTable'
import KeywordDialog from './KeywordDialog'

export const SettingsContainer = styled.div`
	width: 100%;
`

const HASH = config.routeHashes.keywords

const KeywordSettings = () => {
	const intl = useIntl()

	const { keywords, refresh, loading } = useKeywords()

	const dispatch = useDispatch()
	const hash = window.location.hash
	const queryParams = new URLSearchParams(hash.split('?')[1])
	const uuid = queryParams.get('uuid')

	const [addDialogVisible, setDialogVisible] = useState<boolean>(false)

	const showDialog = () => {
		setDialogVisible(true)
	}

	const hideDialog = () => {
		if (uuid) {
			dispatch(push(window.location.pathname + HASH))
		}
		setDialogVisible(false)
	}

	const renderFAB = () => {
		return (
			<FloatingActionBtn
				iconName={'add'}
				text={intl.formatMessage({
					defaultMessage: 'UUSI avainsana',
					description: 'Add keyword',
				})}
				action={showDialog}
			/>
		)
	}

	return (
		<SettingsContainer>
			{<KeywordTable keywords={keywords} loading={loading} />}

			{(typeof uuid === 'string' || addDialogVisible) && (
				<KeywordDialog id={uuid} refresh={refresh} onHide={hideDialog} />
			)}

			{renderFAB()}
		</SettingsContainer>
	)
}

export default KeywordSettings
